import { RouteConfig } from "vue-router";

const cajaChicasTalca: RouteConfig = {
  path: "/cajaChicasTalca",
  name: "cajaChicasTalca",
  component: () => import(/* webpackChunkName: "caja-chicas-talca" */ "@/views/CajaChicasTalca.vue"),
};

export default cajaChicasTalca;
